import './lib/bufferPolyfill'
// Шрифты — как в Paper (2026-09-24): DM Sans на всё, DM Mono только для кода/хэшей.
// Nunito — шрифт системы Soft (tokens.css, --font-soft): переносимые поверхности
// включают его на своих элементах, остальное пока на DM Sans.
import '@fontsource-variable/dm-sans'
import '@fontsource-variable/nunito'
import '@fontsource/dm-mono/400.css'
import '@fontsource/dm-mono/500.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { kickoffPairRouteBoot } from './lib/pairRouteBoot'
import './styles/tokens.css'

// Direct token-page load: start the PairPage chunk and the read-only /resolve
// request while the bundle evaluates, before React's first commit. No-op on
// non-pair routes; the seed/WS barriers in usePairFeed are unchanged.
kickoffPairRouteBoot(window.location.pathname)

const container = document.getElementById('root')
if (!container) {
  throw new Error('#root not found in index.html')
}

// No <Provider>: PR0.1 uses Jotai's default store, which getDefaultStore()
// in atoms/health.ts writes to. Wrap in a Provider later when we need
// per-route stores (PR1.4+).
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
)
